import React, { useEffect } from "react";
import { BookingEngine as BookingEngineComponent } from "@amenitiz/booking-engine";
import { setBookingWindowValues } from "./setBookingWindowValues";
const analyticsCookieAccepted = () => {
  const regex = new RegExp(`(^| )gdpr-banner=([^;]+)`);
  const match = document.cookie.match(regex);
  if (match) {
    const value = match[2];
    if (value === "reject") {
      return false;
    }
    if (value === "accept") {
      return true;
    }
    try {
      const cookiesObject = JSON.parse(value);
      return cookiesObject.analytics;
    } catch (e) {
      return false;
    }
  }
  return false;
};
const initHotjar = () => {
  (function (h, o, t, j, a, r) {
    h.hj = h.hj || function () {
      (h.hj.q = h.hj.q || []).push(arguments);
    };
    h._hjSettings = {
      hjid: 5063957,
      hjsv: 6
    };
    a = o.getElementsByTagName("head")[0];
    r = o.createElement("script");
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
};
export const BookingEngine = _ref => {
  let {
    maxAdults,
    maxChildren,
    model = "",
    locale,
    isFullAddressRequired,
    googleMapsApiKey,
    vgsVaultId,
    hotelName,
    propertyType,
    propertySize,
    subscriptionPlan,
    hotelId,
    hotelEmail,
    hasPromocodeEnabled,
    regions,
    hotjarEnabled,
    clientBookingToken,
    vgsEnvironment,
    roomId
  } = _ref;
  const onClose = data => {
    setBookingWindowValues({
      ...data,
      locale,
      model
    });
  };
  useEffect(() => {
    if (hotjarEnabled && analyticsCookieAccepted() && window.eventbus) {
      window.eventbus.on(window.EVENTS.SHOW_BOOKING_SIDE_PANEL, () => {
        initHotjar();
      });
    }
  }, []);
  const fullScreenBookingEngineRendered = document.querySelector('div[data-react-class="BookingEngineFullScreen/index"]');
  if (fullScreenBookingEngineRendered) return null;
  return /*#__PURE__*/React.createElement(BookingEngineComponent, {
    isSearching: false,
    maxAdults: maxAdults,
    maxChildren: maxChildren,
    locale: locale,
    onClose: onClose,
    isFullAddressRequired: isFullAddressRequired,
    googleMapsApiKey: googleMapsApiKey,
    vgsVaultId: vgsVaultId,
    hotelId: hotelId,
    hotelName: hotelName,
    propertyType: propertyType,
    propertySize: propertySize,
    subscriptionPlan: subscriptionPlan,
    hotelEmail: hotelEmail,
    hasPromocodeEnabled: hasPromocodeEnabled,
    regions: regions,
    clientBookingToken: clientBookingToken,
    vgsEnvironment: vgsEnvironment,
    roomId: roomId
  });
};
export default BookingEngine;